import clsx from 'clsx';
import type { ChangeEventHandler, PropsWithChildren } from 'react';
import styles from './CourseRadioButton.module.scss';
import type { CourseRadioButtonProps } from './types';

const CourseRadioButton = ({
  name,
  value,
  children,
  disabled,
  checked,
  onChange,
}: CourseRadioButtonProps) => {
  const handleOnChange: ChangeEventHandler<HTMLInputElement> | undefined = (
    $event
  ) => {
    onChange?.($event.currentTarget.value);
  };

  if (!value) {
    return <div className={styles.noValue}>{children}</div>;
  }

  return (
    <label
      className={clsx(styles.label, {
        [styles.checked]: checked,
        [styles.disabled]: disabled,
      })}
    >
      <input
        type="radio"
        name={name}
        value={value}
        onChange={handleOnChange}
        className={styles.input}
        disabled={disabled}
        checked={checked}
      />
      {children}
    </label>
  );
};

const CourseRadioButtonInfo = ({ children }: PropsWithChildren) => (
  <span className={styles.info}>{children}</span>
);

CourseRadioButton.SubText = CourseRadioButtonInfo;

export default CourseRadioButton;
